import {
  SizesState,
  SizesActionTypes,
  SET_HEADER_HEIGHT,
  SET_WINDOW_HEIGHT,
  SET_WINDOW_WIDTH,
  SET_SERVICES_HEIGHT,
  SET_TIZER_HEIGHT,
  SET_CATEGORY_HEIGHT,
  RESET_CATEGORIES_HEIGHT,
} from './types';

const initialState: SizesState = {
  headerHeight: 0,
  windowWidth: 0,
  windowHeight: 'auto',
  categoriesHeight: 76,
  categoriesHeightIds: [],
  servicesHeight: 0,
  tizerHeight: 0,
  maxHeight: 0,
};

/**
 * Определение максимальной высоты блоков каталога
 * @param state Хранилище состояний sizes
 * @param newHeight Последняя измененная высота
 */
const getMaxHeight = function (state: SizesState, newHeight: number) {
  if (
    newHeight > state.categoriesHeight &&
    newHeight > state.tizerHeight &&
    newHeight > state.servicesHeight
  ) {
    return newHeight;
  }
  if (
    state.categoriesHeight > state.tizerHeight &&
    state.categoriesHeight > state.servicesHeight
  ) {
    return state.categoriesHeight;
  }
  if (
    state.servicesHeight > state.categoriesHeight &&
    state.servicesHeight > state.tizerHeight
  ) {
    return state.servicesHeight;
  }
  return state.tizerHeight;
};

export function sizesReducer(
  state: SizesState = initialState,
  action: SizesActionTypes
): SizesState {
  var maxHeight = 0;
  var categoriesHeight;
  var categoriesHeightIds;
  switch (action.type) {
    case SET_HEADER_HEIGHT:
      return {
        ...state,
        headerHeight: action.payload,
      };
    case SET_WINDOW_HEIGHT:
      return {
        ...state,
        windowHeight: action.payload,
      };
    case SET_WINDOW_WIDTH:
      return {
        ...state,
        windowWidth: action.payload,
      };
    case SET_SERVICES_HEIGHT:
      maxHeight = getMaxHeight(state, action.payload);
      return {
        ...state,
        servicesHeight: action.payload,
        maxHeight,
      };
    case SET_TIZER_HEIGHT:
      maxHeight = getMaxHeight(state, action.payload);
      return {
        ...state,
        tizerHeight: action.payload,
        maxHeight,
      };
    case SET_CATEGORY_HEIGHT:
      categoriesHeight = state.categoriesHeight;
      categoriesHeightIds = state.categoriesHeightIds;
      if (!categoriesHeightIds.includes(action.id)) {
        categoriesHeight += action.height;
        categoriesHeightIds.push(action.id);
      }
      maxHeight = getMaxHeight(state, categoriesHeight);
      return {
        ...state,
        categoriesHeight,
        maxHeight,
      };
    case RESET_CATEGORIES_HEIGHT:
      return {
        ...state,
        categoriesHeight: 76,
        categoriesHeightIds: [],
      };
    default:
      return state;
  }
}
